import { Component, OnDestroy, OnInit, Optional, QueryList, ViewChildren } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HelpSideDrawerTemplateRef, HelpSideDrawerTemplateRefService } from '../help-side-drawer-template-ref.service';

@Component({
  selector: 'app-help-side-drawer-container',
  templateUrl: './help-side-drawer-container.component.html',
  styleUrls: ['./help-side-drawer-container.component.scss'],
})
export class HelpSideDrawerContainerComponent implements OnInit, OnDestroy {
  @ViewChildren(MatDrawer) drawerReference: QueryList<MatDrawer>;
  sideDrawerTemplate$: Observable<HelpSideDrawerTemplateRef>;
  private subscriptions: Subscription[] = [];

  constructor(
    @Optional()
    private helpSideDrawerTemplateRefService: HelpSideDrawerTemplateRefService,
  ) {}

  ngOnInit(): void {
    if (this.helpSideDrawerTemplateRefService) {
      this.sideDrawerTemplate$ = this.helpSideDrawerTemplateRefService.openTemplate$;

      this.subscriptions.push(
        this.helpSideDrawerTemplateRefService.open$
          .pipe(
            tap((open) => {
              if (!this.drawerReference?.first) {
                return;
              }

              if (open) {
                this.drawerReference.first.open('program');
              } else {
                this.drawerReference.first.close();
              }
            }),
          )
          .subscribe(),
      );
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => {
      s.unsubscribe();
    });
  }
}
